<template>
  <div class="questionWarp">
    <div class="inner">
      <div class="bigTitle">常见问题</div>
      <div class="questionContent">
        <p class="title">{{question.question}}</p>
        <p class="content">{{question.answer}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      data() {
        return {
          question:{}
        }
      },
      created(){
        let _this = this;
        let id = _this.$route.params.id;
        _this.ajpost('/api/account/findQuestionInfo',{id:id},function (data) {
          _this.question = data.data;
        })
      }
    }
</script>
<style>
  @import "../../assets/less/question.css";
</style>



// WEBPACK FOOTER //
// src/components/question/question.vue